import { render, staticRenderFns } from "./EditFormInfoDialog.vue?vue&type=template&id=5791d920&scoped=true"
import script from "./EditFormInfoDialog.vue?vue&type=script&lang=js"
export * from "./EditFormInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5791d920",
  null
  
)

export default component.exports